define('doneable',[], function() {
    'use strict';

    /**
     *  Doneable is a simple single callback Promise-like implementation. Its purpose
     *  is to be able to return a future based on the callback being "done", regardless
     *  of its resolution state (resolve/rejected) liked a normal Promise.
     *
     *  @constructor
     *  @param {Function} [cb] - The main function to execute in the Doneable
     *  @param {Object} [opts] - Options supported are:
     *                            - error - Set the error function to be called on any errors
     */
    function Doneable(cb, opts) {
        var doneable = this,
            doneCallbacks = [],
            state = 'pending';

        opts = opts || {};

        /**
         *  Logs any errors to the opts.error function
         *
         *  @private
         *  @param {Object} [err] - error to log
         */
        function logError(err) {
            if (typeof opts.error === 'function') {
                opts.error(err);
            }
        }


        /**
         *  Executes all the callbacks waiting to be executed in the queue
         *
         *  @private
         */
        function processDoneCallbacks() {
            var i;

            for (i = 0; i < doneCallbacks.length; i++) {
                try {
                    doneCallbacks[i].call(doneable);
                } catch (e) {
                    logError(e);
                }
            }

            doneCallbacks = [];
        }


        /**
         *  Function to be called when the main function is "done"
         *
         *  @private
         */
        function done() {
            processDoneCallbacks();
            state = 'done';
        }


        /**
         *  Assign a callback function when the main function is "done". If the Doneable is already
         *  "done" then the callback will be executed immediately.
         *
         *  @method
         *  @param {Function} [onDone] - Function to queue as a callback when the Doneable is done
         *  @returns {Doneable} - Returns the Doneable instance to support chaining
         */
        doneable.then = function(onDone) {
            if (typeof onDone === 'function') {
                doneCallbacks.push(onDone);
            }

            if (state === 'done') {
                done();
            }

            return doneable;
        };


        // Execute the main function and pass in done()
        try {
            cb(done);
        } catch (e) {
            // If something blows up then we will attempt to log the error
            // but will consider this Doneable instance "done"
            logError(e);
            done();
        }

        return doneable;
    }

    /**
     *  Creates a doneable object based on the completion of one or more doneables
     *  If an element of the passed array isn't a Doneable, we'll immediately consider it done
     *
     *  @method
     *  @param {Array} [parts] - Doneables to complete before calling done
     *  @param {Object} [opts] - Options to be passed to the created Doneable. Options supported are:
     *                            - error - Set the error function to be called on any errors
     *  @returns {Doneable} - Returns a Doneable instance to support chaining
     */
    Doneable.all = function(parts, opts) {
        return new Doneable(function(done) {
            var numDone = 0,
                numParts,
                i,
                curr;

            if (parts && parts.length) {
                numParts = parts.length;
            } else {
                // there is nothing to do, call done
                numParts = 0;
                done();
            }

            function checkNumDone() {
                numDone += 1;
                if (numDone === numParts) {
                    done();
                }
            }

            for (i = 0; i < parts.length; i++) {
                curr = parts[i];

                if (curr instanceof Doneable) {
                    curr.then(checkNumDone);
                } else {
                    // If it isn't a Doneable assume, it is done
                    checkNumDone();
                }
            }
        }, opts);
    };


    return Doneable;
});

